import { isObject } from '../assertFunctions';

export interface JsonCloneOptions {
  replacer: (key: string, passedValue: unknown) => void;
  reviver: (key: string, passedValue: unknown) => void;
}
export const jsonClone = <T>(obj: T, options?: JsonCloneOptions): T => {
  if (options) {
    const { replacer, reviver } = options;
    return JSON.parse(JSON.stringify(obj, replacer), reviver) as T;
  }
  return JSON.parse(JSON.stringify(obj)) as T;
};

/** General json replacer for Map, Set, and Date objects.*/
export function jsonReplacerFunction(
  this: Record<string, unknown>,
  key: string,
  value: unknown,
) {
  const target = this[key];
  if (target instanceof Map) {
    return {
      jsonDataType: 'Map',
      value: [...target.entries()],
    };
  }
  if (target instanceof Set) {
    return {
      jsonDataType: 'Set',
      value: [...target],
    };
  }
  if (target instanceof Date) {
    return {
      jsonDataType: 'Date',
      value: target.toJSON(),
    };
  } else {
    return value;
  }
}

/** General json reviver for Map, Set, and Date objects.*/
export function jsonReviverFunction(key: string, passedValue: unknown) {
  if (isObject(passedValue)) {
    const { jsonDataType, value } = passedValue;
    if (!jsonDataType) return passedValue;
    if (jsonDataType === 'Map') return new Map(value as [string, unknown][]);
    if (jsonDataType === 'Set') return new Set(value as unknown[]);
    if (jsonDataType === 'Date') return new Date(value as string);
  }
  return passedValue;
}

export const jsonObjectClone = <T>(arg: T): T =>
  jsonClone(arg, {
    replacer: jsonReplacerFunction,
    reviver: jsonReviverFunction,
  });
